import React, { useState } from 'react';

import { Grid, GridColumn } from '@progress/kendo-react-grid';
import SvgIcon from '../../CustomeComponents/SvgIcon';
import TikDetailsDialog from './TikDetailsDialog';

const CustomeProcessPanelAndTable = ({ proStepsList, tikNum }) => {
    
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [dialogData, setDialogData] = useState({});
    const titles = {
        "stepCodeText": "שלב",
        "planDateStr": "מועד מתוכנן",
        "execDateStr": "מועד ביצוע",
        "stepStatusText": "סטטוס",
        "hearot": "הערות",
        "total": "מידע נוסף"
    }    

    const LabeledDataItem = (label, value, field) => {
		return <div className="labeled-grid-cell">
			<div className="label">{label}</div>
			{
                field === "total" ?
                    <div dangerouslySetInnerHTML={{ __html: value }} />
                    :
                    <div className="value">{value}</div>
            }
		</div>
	}

	const LabeledCell = (props) => {
		return <td {...props.tdProps}>
			{LabeledDataItem(titles[props.field], props.dataItem[props.field], props.field)}
		</td>
	}

    const SvgIconCell = (props) => {
        const data = props.dataItem;
        const hamlatzaTochen = data.hamlatzaTochen;
        if(hamlatzaTochen) {
            return (
                <td {...props.tdProps} className="icon-cell">
                    {LabeledDataItem('קישור', <SvgIcon icon={"eye"} style={{ cursor: 'pointer' }} onClick={() => toggleDialog(data)} />)}
                </td>
            )
        } else {
            return <td></td>
        }
    }

    const toggleDialog = (dataToShow) => {
        setDialogData(dataToShow);
        setIsDialogOpen(!isDialogOpen);
	}

    // const extractFileName = (str) => {
    //     // Use a regular expression to match all characters except digits and hyphen
    //     const fName = str.replace(/[\d-]+/g, '').trim();
    //     return fName;
    // }

    return (
        <div>
            <Grid data={proStepsList} >
                <GridColumn field="stepCodeText" title={titles.stepCodeText} cell={LabeledCell} />
                <GridColumn field="planDateStr" title={titles.planDateStr} cell={LabeledCell} />
                <GridColumn field="execDateStr" title={titles.execDateStr} cell={LabeledCell} />
                <GridColumn field="stepStatusText" title={titles.stepStatusText} cell={LabeledCell} />
                <GridColumn field="hearot" title={titles.hearot} cell={LabeledCell} />
                <GridColumn field="total" title={titles.total} cell={LabeledCell} />
                <GridColumn title="פירוט" cell={SvgIconCell} headerClassName={'icon-header-cell'} />
            </Grid>

            {isDialogOpen && <TikDetailsDialog dialogData={dialogData} tikNum={tikNum} toggleDialog={toggleDialog}/>}
        </div>
    )
}

export default CustomeProcessPanelAndTable